<template>
  <div class="card" :class="[`card-${getCardColor}`, { 'has-hover': hasHover }, { 'selected': selected }, { 'sound': isSoundCard }, { 'animation-active': cardAnimationActive }]">
      <img :src="getImg" alt="Kidjo Show" :class="isSoundCard ? 'sound-card-dimensions':  'card-img-dimensions'">
      <div v-if="hasHover" class="hover-mask"></div>
  </div>
</template>

<script>
  import { CardType, MediaType } from '../services/cards.service';

  export default {
    props: {
      item: {
        required: true,
        // DEV NOTE: add validator
      },
      hasHover: {
        default: true,
      },
      selected: {
        default: false,
      },
      cardAnimationActive: {
        default: false,
      },
    },
    computed: {
      isSoundCard() {
        return this.item.type === CardType.Sound;
      },
      getCardColor() {
        if (this.isSoundCard) {
          return 'transparent';
        }

        if (this.item.mediaType === MediaType.MixedGames) {
          return 'white';
        }

        return this.item.color || 'red';
      },
      getImg() {
        if (this.item.type === CardType.Folder) {
          return this.item.imageUrl;
        }

        if (this.isSoundCard) {
          return require(`../assets/images/${this.item.sound}.png`);
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '../assets/styles/breakpoints.scss';

  @mixin radial-gradient($start-colour, $start-position, $end-colour, $end-position) {
    background: -moz-radial-gradient(center, ellipse cover, $start-colour $start-position, $end-colour $end-position);
    background: -webkit-gradient(radial, center center, 0px, center center, 100%, Colour-stop($start-position,$start-colour), Colour-stop($end-position,$end-colour));
    background: -webkit-radial-gradient(center, ellipse cover, $start-colour $start-position,$end-colour $end-position);
    background: -o-radial-gradient(center, ellipse cover, $start-colour $start-position,$end-colour $end-position);
    background: -ms-radial-gradient(center, ellipse cover, $start-colour $start-position,$end-colour $end-position);
    background: radial-gradient(ellipse at center, $start-colour $start-position,$end-colour $end-position);
  }

  @mixin transition($transition) {
    -moz-transition: $transition;
    -o-transition: $transition;
    -webkit-transition: $transition;
    transition: $transition;
  }

  $red: #ec0008;
  $blue: #0074e1;
  $yellow: #ffac01;
  $green: #1ba215;
  $orange: #e85800;
  $purple: #950f71;
  $white: #FFFFFF;

  .card {
    position: relative;
    border: 8px solid white;
    border-radius: 35px;
    overflow: hidden;
    aspect-ratio: 7 / 8;
    width: 220px;
    height: auto;

    &::after {
      display: block;
      padding-top: 100%;
      content: '';
    }
    @media (min-width: $breakpoint-2xl) {
      width: 320px;
      border-radius: 55px;
      border: 8px solid white;
    }
    @media (max-height: $breakpoint-xs) {
      width: 150px;
      border: 5px solid white;
      border-radius: 25px;
    }
    @media (max-width: $breakpoint-xs) {
      width: 160px;
    }
    @media (max-height: $breakpoint-2xs) {
      width: 110px;
      height: 130px;
      min-width: 110px;
    }
    @media (max-width: $breakpoint-2xs) {
      // min-height: 145px;
      // min-width: 130px;
      // height: 145px;
      // width: 130px;
      // max-height: 145px;
      // max-width: 130px;
    }
    @media (orientation: portrait) {
        min-height: 185px;
        min-width: 165px;
        aspect-ratio: 7/8;

      @media (min-width: $breakpoint-md) {
        // min-height: 240px;
        min-width: 225px;
      }

      // @media (min-width: $breakpoint-sm) {
      //   width: 220px;
      // }

      @media (min-width: $breakpoint-sm) {
        min-height: 280px;
        min-width: 255px;
        border: 9px solid white;

        &--mobile-only {
          width: 220px;
          overflow: unset !important;
        }
      }
      @media (max-width: $breakpoint-2xs) {
        min-height: 180px;
        min-width: 130px;
        border: 6px solid white;
      }
    }

    // @media (orientation: landscape) {
    //   flex: 0 0 100px;
    //   margin: 0 10px;

    //   @media (min-width: $breakpoint-xs) {
    //     flex: 0 0 120px;
    //   }

    //   @media (min-width: $breakpoint-sm) {
    //     flex: 0 0 140px;
    //   }

    //   @media (min-width: $breakpoint-lg) {
    //     flex: 0 0 240px;
    //     margin: 0 20px;
    //     border-width: 6px;
    //   }

    //   @media (min-width: $breakpoint-2xl) {
    //     flex: 0 0 320px;
    //   }
    // }

    &.has-hover {
      cursor: pointer;

      @media (min-width: $breakpoint-lg) {
        &:focus,
        &:hover {
          opacity: 1;
          @include transition(opacity .2s ease);
          // transform: scale(1.05);
        }
      }

      @media (min-width: $breakpoint-xl) {
        &:focus,
        &:hover {
          border-width: 10px;
          // transform: scale(1.2);
        }
      }

      &.selected {
        .hover-mask {
          opacity: 1;
          @include transition(opacity .2s ease);
        }
        @media (min-width: 850px) {
         transform: scale(1.1);
        }
      }

      &.sound {
        display: flex;
        justify-content: center;
        align-items: center;
        @media (min-width: $breakpoint-lg) {
          display: none;
        }
      }

      .hover-mask {
        background: rgba(255, 255, 255, 0.3);
        height: 100%;
        left: 0;
        opacity: 0;
        position: absolute;
        top: 0;
        width: 100%;
      }
    }

    &.animation-active {
      img {
        opacity: 0;
        padding-bottom: 100px
      }
    }

    &.card-transparent {
      backdrop-filter: blur(11px);
    }
  
    &.card-red {
      @include radial-gradient(lighten($red, 30%), 0%, $red, 100%);
    }
  
    &.card-blue {
      @include radial-gradient(lighten($blue, 30%), 0%, $blue, 100%);
    }
  
    &.card-yellow {
      @include radial-gradient(lighten($yellow, 30%), 0%, $yellow, 100%);
    }
  
    &.card-green {
      @include radial-gradient(lighten($green, 30%), 0%, $green, 100%);
    }
  
    &.card-orange {
      @include radial-gradient(lighten($orange, 30%), 0%, $orange, 100%);
    }
  
    &.card-purple {
      @include radial-gradient(lighten($purple, 30%), 0%, $purple, 100%);
    }
  
    &.card-white {
      background-color: $white;
    }

    img {
      transition: opacity .15s ease-out, padding .25s ease-in;
      &.card-img-dimensions {
        display: flex;
        height: 100%;
        width: 100%;
        min-width: 100%;
      }
      &.sound-card-dimensions {
        display: block;
        max-width: 77%;
        max-height: 77%;
      }
    }
  }
</style>
